import React from 'react';

const Home = () => (
  <div className="home-container">
    <h1>Welcome to our page</h1>
    <p>
      Mathematics is the science that deals with the logic of shape, quantity
      and arrangement. Mathematics plays a vital role in all aspects of life,
      whether in everyday matters such as time tracking, driving, cooking, or
      jobs such as accounting, finance, banking, engineering, and software.
    </p>

    <p>
      Mathematics is the cradle of all creations, without which the world cannot
      move an inch. It makes our life orderly and prevents chaos. Certain
      qualities that are nurtured by mathematics are power of reasoning,
      creativity, abstact or spatial thinking, critical thinking and even
      effective communication.
    </p>
  </div>
);

export default Home;
